/***************************************************************************

    Copyright (C) 2020 Ravenpod, Inc.
    All rights reserved.

    This material contains CONFIDENTIAL INFORMATION
    that is the property of Ravenpod.com, Inc.
    Any unauthorized use, duplication or disclosure is prohibited.

***************************************************************************/
import store from '../store'

export default function authHeader() {

    let user = store.getters['auth/user']
    let jwtToken = store.getters['auth/idJwtToken']

    if (user && jwtToken) {
        return { 'Accept-Version': '~2', 'Authorization': `Bearer ${jwtToken}` };
    } else {
        return { 'Accept-Version': '~2' };
    }

}